import React, { useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import { reset } from "redux-form";
import {
  isSessionExpired,
  userLogin,
  redirectToAzure,
} from "../../actions/login/loginActions";
import history from "../../history";
import LoginForm from "./LoginForm";
 
const LoginPage = (props) => {
  const dispatch = useDispatch();
  const [selectionMade, setSelectionMade] = useState(false); // Track if user made a selection
  const [isCompanyEmployee, setIsCompanyEmployee] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false); // Spinner state
 
  // Handle checkbox selection
  const handleCheckboxChange = (isEmployee) => {
    setIsCompanyEmployee(isEmployee);
    setSelectionMade(true);
 
    if (isEmployee) {
      // Redirect company employees to Azure
      setIsRedirecting(true);
      dispatch(redirectToAzure());
    }
  };
 
  // Handle form submission for non-company employees
  const onSubmit = (formValues) => {
    const payload = { ...formValues };
    props.userLogin(payload);
    dispatch(reset("loginform"));
  };
 
  // Validate session for non-company employees
  useEffect(() => {
    if (!isSessionExpired() && !isCompanyEmployee) {
      history.push("/home");
    }
  }, [isCompanyEmployee]);
 
 
  return (
 
    <div className="custom-container my-5">
  {isRedirecting ? (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="custom-spinner spinner-border text-primary" role="status"></div>
      <p className="mt-3">Redirecting to Microsoft authentication...</p>
    </div>
  ) : !selectionMade ? (
    <div className="row align-items-center custom-shadow p-4 rounded bg-white">
      {/* Left Section */}
      <div className="col-md-6">
  <h2 className="mb-4 text-primary  fw-bold">Welcome to iEvaluate</h2>
  <p className="mb-4  text-secondary fs-5">
    Please select an option from below to login:
  </p>
  <div className="d-grid gap-3">
  <button
    className="btn btn-light btn-lg text-center p-4 rounded-pill shadow-sm hover-effect"
    onClick={() => handleCheckboxChange(true)}
  >
   <strong className="button-text">ICICI Lombard User</strong>
    <br />
  </button>
  <button
    className="btn btn-light btn-lg text-center p-4 rounded-pill shadow-sm hover-effect"
    onClick={() => handleCheckboxChange(false)}
  >
    <strong className="button-text">Registered Buyer</strong>
    <br />
  </button>
</div>

</div>
 
 
      {/* Right Section */}
      <div className="col-md-6 text-center">
        <img
          src="/assets/images/LoginPage1.png"
          alt="Login Illustration"
          className="custom-img-fluid img-fluid rounded"
        />
      </div>
    </div>
  ) : (
    <div>
          <img
            className="loginImage"
            src="/assets/images/LoginPage1.png"
            alt="loginPagePic"
          />
          <div className="loginContainer">
            <h3 className="loginTitle">Login</h3>
        {!isCompanyEmployee && (
          <LoginForm
            onSubmit={onSubmit}
           
          />
        )}
      </div>
    </div>
  )}
</div>
 
  );
 
};

 
export default connect(null, {
  userLogin,
  redirectToAzure,
})(LoginPage);
